package org.hs_soft.runmynesto.domain.model.home.home.global_search


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class CashAssist(
    @SerialName("globalSearch")
    val globalSearch: List<GlobalSearch?>?
)